import e from "react";
const u = ({
  maxAmount: r,
  onChange: s,
  value: t,
  disabled: o,
  onDisabledClick: l
}) => {
  const i = (n) => {
    o ? l() : n > r ? s(r) : s(n);
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: "relative flex max-w-[7rem] items-center",
      "data-testid": "room-input"
    },
    /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        "data-testid": "decrement-button",
        "data-input-counter-decrement": "quantity-input",
        "aria-label": I18n.t("booking_engine.information.decrease_quantity"),
        className: `h-10 rounded-s-lg border border-neutrals-15 p-3 focus:outline-none focus:ring-2 focus:ring-primary-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-60 ${o ? "cursor-not-allowed bg-white" : "bg-neutrals-05 hover:bg-gray-200"} disabled:cursor-not-allowed disabled:bg-white`,
        onClick: () => i(t - 1),
        disabled: t <= 0
      },
      /* @__PURE__ */ e.createElement(
        "svg",
        {
          className: `h-3 w-3 ${o || t <= 0 ? "text-neutrals-40" : "text-neutrals-90"}`,
          "aria-hidden": "true",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 18 2"
        },
        /* @__PURE__ */ e.createElement(
          "path",
          {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M1 1h16"
          }
        )
      )
    ),
    /* @__PURE__ */ e.createElement(
      "input",
      {
        type: "text",
        "data-testid": "room-input-field",
        className: `block h-10 w-[38px] border border-x-0 border-neutrals-15 py-2.5 text-center text-sm ${o ? "bg-white text-neutrals-40" : "text-neutrals-70"} focus:border-primary-60 focus:ring-2 focus:ring-primary-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-60`,
        value: t,
        required: !0,
        onChange: (n) => i(parseInt(n.target.value)),
        disabled: o,
        autoComplete: "off",
        "aria-label": I18n.t("booking_engine.information.room_quantity")
      }
    ),
    /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        "data-testid": "increment-button",
        "aria-label": I18n.t("booking_engine.information.increase_quantity"),
        className: `h-10 rounded-e-lg border border-neutrals-15 p-3 focus:outline-none focus:ring-2 focus:ring-primary-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-60 ${o ? "cursor-not-allowed bg-white" : "bg-neutrals-05 hover:bg-gray-200"} disabled:cursor-not-allowed disabled:bg-white`,
        onClick: () => i(t + 1),
        disabled: t >= r
      },
      /* @__PURE__ */ e.createElement(
        "svg",
        {
          className: `h-3 w-3 ${o || t >= r ? "text-neutrals-40" : "text-neutrals-90"}`,
          "aria-hidden": "true",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 18 18"
        },
        /* @__PURE__ */ e.createElement(
          "path",
          {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M9 1v16M1 9h16"
          }
        )
      )
    )
  );
};
export {
  u as RoomInput
};
